// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1rJ8Y","title":"BackImages_title__gvU8b","images":"BackImages_images__u1abg"};